import { PaymentAccountDTO } from '../dto/payment-account.dto';
import { PaymentCardProvider } from '../../payment-card-provider/model/payment-card-provider';

export class PaymentAccount {
  public name: string;
  public provider: PaymentCardProvider;

  public static convertFromDTO(
    paymentAccountDTO: PaymentAccountDTO
  ): PaymentAccount {
    const paymentAccount: PaymentAccount = new PaymentAccount();
    if (!paymentAccountDTO) {
      return null;
    }

    paymentAccount.name = paymentAccountDTO.fullName;
    paymentAccount.provider = PaymentCardProvider.convertFromDTO(
      paymentAccountDTO.pcp
    );
    return paymentAccount;
  }
}
